import classnames from 'classnames';
import { ReactComponent as Logo } from 'src/assets/images/atomica logo.svg';
import * as styles from './AtomicaLogo.module.scss';

const AtomicaLogo = ({ style = {}, className, glowInDarkMode = false }) => (
  <Logo
    alt="Atomica.ai"
    width="100%"
    height="100%"
    style={{
      aspectRatio: 6.5,
      width: 'min(224px, 100%)',
      height: '26px',
      maxHeight: '100%',
      maxWidth: '100%',
      ...style,
    }}
    className={classnames(styles.logo, glowInDarkMode && styles.glowInDarkMode, className)}
  />
);

export default AtomicaLogo;
